import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { constructStack } from "@smithy/middleware-stack";
export var Client = /*#__PURE__*/function () {
  function Client(config) {
    _classCallCheck(this, Client);
    this.config = config;
    this.middlewareStack = constructStack();
  }
  _createClass(Client, [{
    key: "send",
    value: function send(command, optionsOrCb, cb) {
      var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
      var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
      var useHandlerCache = options === undefined && this.config.cacheMiddleware === true;
      var handler;
      if (useHandlerCache) {
        if (!this.handlers) {
          this.handlers = new WeakMap();
        }
        var handlers = this.handlers;
        if (handlers.has(command.constructor)) {
          handler = handlers.get(command.constructor);
        } else {
          handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
          handlers.set(command.constructor, handler);
        }
      } else {
        delete this.handlers;
        handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
      }
      if (callback) {
        handler(command).then(function (result) {
          return callback(null, result.output);
        }, function (err) {
          return callback(err);
        }).catch(function () {});
      } else {
        return handler(command).then(function (result) {
          return result.output;
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$config, _this$config$requestH, _this$config$requestH2;
      (_this$config = this.config) === null || _this$config === void 0 ? void 0 : (_this$config$requestH = _this$config.requestHandler) === null || _this$config$requestH === void 0 ? void 0 : (_this$config$requestH2 = _this$config$requestH.destroy) === null || _this$config$requestH2 === void 0 ? void 0 : _this$config$requestH2.call(_this$config$requestH);
      delete this.handlers;
    }
  }]);
  return Client;
}();